import React from 'react'
import { Box, Button, Stack, Typography, Paper } from '@mui/material'
import { ErrorOutline } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const AccessDenied = ({ denied, children }) => {
  const navigate = useNavigate()

  if (denied) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <Paper
          elevation={6}
          sx={{
            p: 6,
            borderRadius: 4,
            maxWidth: 480,
            textAlign: 'center',
            backdropFilter: 'blur(6px)',
          }}
        >
          <Stack spacing={3} alignItems="center">
            <ErrorOutline color="error" sx={{ fontSize: 72 }} />

            <Typography variant="h4" fontWeight="bold">
              Access Denied
            </Typography>

            <Typography variant="body1" color="text.secondary">
              You don’t have permission to view this page. Please contact your
              administrator if you think this is a mistake.
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="center"
              width="100%"
            >
              <Button
                variant="outlined"
                color="primary"
                onClick={() => navigate(-1)}
                fullWidth
              >
                Go Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate('/')}
                fullWidth
              >
                Return Home
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    )
  } else {
    return children
  }
}

export default AccessDenied
